import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-governing-body',
  templateUrl: './governing-body.component.html',
  styleUrls: ['./governing-body.component.scss'],
})
export class GoverningBody implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
